<template>
    <div class="container-fluid">
        <div class="card shadow mt-5">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.gestionPatient', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-lg-4 mt-2" v-if="hasAdminRole">
                        <router-link :to="{ name: 'roles' }">
                            <stats-card :title="$tc('message.roles', 2)" type="gradient-purple" icon="fas fa-microscope"
                                class="mb-4 mb-xl-0"></stats-card>
                        </router-link>
                    </div>
                    <div class="col-lg-4 mt-2" v-if="hasAdminRole">
                        <router-link :to="{ name: 'permissions' }">
                            <stats-card :title="$tc('message.permissions', 2)" type="gradient-purple" icon="fas fa-microscope"
                                class="mb-4 mb-xl-0"></stats-card>
                        </router-link>
                    </div>
                    <div class="col-lg-4 mt-2" v-if="hasAdminRole">
                            <router-link :to="{ name: 'user-permissions' }">
                                <stats-card :title="$tc('message.userPermissions', 2)" type="gradient-purple" icon="fas fa-microscope"
                                    class="mb-4 mb-xl-0"></stats-card>
                            </router-link>
                        </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from "lodash";

export default {
    name: "Facturations",
    computed: {
        ...mapGetters(['hasAdminRole', "userInstitutions",
            'hasGestionnaireRole', 'hasMedecinControleRole', 'hasPraticienRole', 'hasSouscripteurRole', 'isComptable', 'hasPraticienRole', 'hasAssistante']),

        can: function () {
            return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
        }
    },

    methods: {
        getUserInstitutions() {
            let args = {
                offset: this.offset,
                limit: this.limit
            };

            this.$store.dispatch('getUserInstitutions', { args: args });
        },

        goToCustomInstitution() {
            if (this.isComptable && !this.hasMedecinControleRole && !this.hasPraticienRole && !this.hasGestionnaireRole && !this.hasAssistante) {
                if (!_.isUndefined(this.userInstitutions)) {
                    if (this.userInstitutions.length > 0) {
                        let slug = this.userInstitutions[0].slug;
                        return this.$router.resolve({ name: 'etablissement-prestations-list', params: { prestation_etablissement: slug } }).href;
                    }
                    return '';
                }
            }
            else {
                return this.$router.resolve({ name: 'etablissement-prestations' }).href;
            }

        }
    },
    mounted() {
        if (this.isComptable && !this.hasMedecinControleRole && !this.hasPraticienRole && !this.hasGestionnaireRole && !this.hasAssistante) {
            this.getUserInstitutions();
        }
    }
}
</script>

<style scoped></style>
